<template>

    <div class="h-100">

        <div class="" v-html="'<style>' + randomBanner.css_code + '</style>'" v-if="randomBanner.css_code"></div>
        <!--<div v-html="'<script>' + randomBanner.js_code + '</script>'" v-if="randomBanner.js_code"></div>-->

        <div class="h-100 zone" v-html="randomBanner.html_code" v-if="randomBanner"></div>

    </div>

</template>

<script>
    export default {
        props: [
            'uid',
        ],
        computed: {
            randomBanner() {

                let bannersInZone = this.$page.props.banners.filter((banner) => {

                    let found = false;
                    _.each(banner.zones, (zone) => {
                        if (zone.uid === this.uid) {
                            found = true;
                        }
                    });

                    return found;
                });

                if (bannersInZone) {
                    return _.sample(bannersInZone);
                }

                return false;
            }
        }
    }
</script>

<style scoped>

</style>